import { useMutation } from "@tanstack/react-query";
import { EndPoints } from "../../../Constants/endpoints";
import { GeneralResponse } from "../../../interface/GeneralResponse";
import Api from "../../generalApi/Api";
import { useNavigate } from "react-router-dom";
import { Methods } from "../../../Constants/ApiConstants";

export interface ResetPasswordRequest {
  Id: number | null;
  VerificationCode: string;
  Password: string;
}

export const useResetPassword = () => {
  const navigate = useNavigate();
  const mutation = useMutation({
    mutationFn: (data: ResetPasswordRequest): Promise<GeneralResponse> => {
      return Api<ResetPasswordRequest, GeneralResponse>({
        method: Methods.POST,
        endpoint: EndPoints.ResetPassword,
        body: data,
      });
    },
    onSuccess: (data) => {
      return data;
    },
  });

  return mutation;
};
